import styled from "styled-components";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, TextField, Typography, Box, Alert } from "@mui/material";

const QaabDialogStyles = {
  Container: styled.div`
    width: 100%;
    min-height: 600px;
    /* padding: 20px; */
    /* background: url(/images/bg2.png) 0 0;*/
  `,
  FlexRow: styled.div`
    display: flex;
    flex-direction: row;
    gap: 0;
  `,
  // フレックス間隔
  FlexBetween: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0;
  `,
  Dialog: styled(Dialog)`
    /*background: url(/images/bg2.png) 0 0;*/
    z-index: 1400 !important; // partsInfoDialogより高い値
  `,
  DialogTitle: styled(DialogTitle)`
    background: url(/images/bg2.png) 0 0;
  `,
  Title: styled.div`
    background: url(/images/window_title.png) no-repeat 0 50%;
    padding: 5px 0 0 35px;
    color: #333;
    font-size: 24px;
    line-height: 30px;
    font-weight: bold;
  `,

  OrderDetail: styled.div`
    .wrap {
      background-color: #ffa;
      border: 1px solid #f93;
      border-radius: 5px;
      color: #333;
      line-height: 33px;
      padding: 0 5px;
      overflow: hidden;
    }

    dl {
      margin: 0;
    }

    dt {
      float: left;
      font-weight: bold;
      padding-right: 5px;
      font-size: 18px;
    }

    dt.order {
      clear: both;
      float: left;
    }

    dd {
      color: #f00;
      float: left;
      padding-right: 15px;
      font-size: 18px;
    }
  `,

  Faq: styled.div`
    margin-top: 20px;

    h3 {
      padding: 5px 0 0 5px;
      color: #333;
      font-size: 20px;
      line-height: 30px;
      margin: 30px 0 10px;
      font-weight: bold;
      border-left: 5px solid #36f;
    }

    dl {
      margin: 10px 0;
    }

    dt {
      background: #ffe4e4;
      padding: 4px;
    }

    dd {
      padding: 4px 4px 4px 30px;
      word-break: break-all;
      text-wrap: normal;
    }

    ul li {
      list-style: disc;
    }

    .que {
      display: inline-block;
      background: #f33;
      color: #fff;
      font-weight: bold;
      padding: 2px 5px;
      border-radius: 2px;
      margin-right: 6px;
    }

    .ans {
      display: inline-block;
      background: #36f;
      color: #fff;
      font-weight: bold;
      padding: 2px 5px;
      border-radius: 2px;
      margin-right: 6px;
    }

    p.order-complete {
      margin: 10px 0;
      text-align: center;
    }

    .error {
      background: #ffebee;
      color: #c62828;
      border: 1px solid #ffcdd2;
      border-radius: 4px;
      padding: 10px;
      margin: 10px 0;
      font-size: 14px;
    }

    .close-link {
      display: inline-block;
      margin-top: 10px;
    }
  `,

  ImportantBtn: styled.button`
    display: inline-block;
    background: #3366ff url(/images/arrow_important.png) no-repeat 10px 50%;
    color: #fff;
    height: 33px;
    border-style: solid;
    border-width: 1px;
    border-color: #99ccff #1c3dc0 #1c3dc0 #99ccff;
    border-radius: 5px;
    text-align: center;
    line-height: 33px;
    font-size: 18px;
    font-weight: bold;
    padding: 0 10px 0 30px;
    cursor: pointer;

    &:hover {
      filter: brightness(0.9);
    }

    &:disabled {
      background-color: #d4d4d4 !important;
      border-color: #e8e8e8 #aaa #aaa #e8e8e8 !important;
      color: #fff !important;
      cursor: default !important;
    }
  `,

  BtnGray: styled.button`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border-style: solid;
    border-width: 1px;
    border-color: #eee #999 #999 #eee;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    margin-left: 8px;
    &:hover {
      filter: brightness(0.9);
    }
  `,

  CloseIconLink: styled.a`
    position: absolute;
    top: 30px;
    right: 40px;
    cursor: pointer;

    &:hover {
      color: #f00;
    }

    img {
      vertical-align: middle;
    }
  `,

  SimpleTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
    margin-bottom: 20px;

    th {
      border: 1px solid #999;
      padding: 2px;
      text-align: center;
      background: #ffe4e4;
    }
    td {
      border: 1px solid #999;
      padding: 6px 8px;
      vertical-align: top;
      padding: 2px;
      text-align: center;
      background: #ffffff;
    }

    .date,
    .locale,
    .ctrl {
      text-align: center;
    }

    .txt {
      word-break: break-all;
      text-align: left;
      width: 55%;
      text-wrap: normal;
    }
  `,

  WarningBox: styled.div`
    background-color: #ffff00;
    padding: 8px;
    margin-top: 6px;

    ul {
      padding-left: 18px;
      margin: 0;
    }
  `,

};

export default QaabDialogStyles;
